import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Kmoe News · Your Source for Reliable Information</p>
        <h1>Stay Informed with Kmoe News</h1>
        <p className="lede">
          Discover the latest news and insights that matter to you. Our platform delivers timely updates and in-depth articles to keep you connected with the world around you.
        </p>
        <div className="cta-row">
          <a href="/latest" target="_self">
            Read the Latest News
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important stories as they unfold. Our dedicated team ensures you never miss a beat.
          </p>
        </article>
        <article>
          <h2>In-Depth Analysis</h2>
          <p>
            Explore comprehensive articles that provide context and insights into current events, helping you understand the bigger picture.
          </p>
        </article>
        <article>
          <h2>Community Voices</h2>
          <p>
            Engage with diverse perspectives from our community contributors, giving you a well-rounded view of the issues that matter.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;